import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { eventBus } from '@atc/cai-event-bus';
import { WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, WALLET_UPDATE_DATA_AFTER_LOGIN_REQUEST } from 'wallet-manager';
const AUTH_SIGNIN_COMPLETE = 'auth.signin';
function useWalletInitialization(_ref) {
  let {
    paymentsDuck
  } = _ref;
  const dispatch = useDispatch();
  function handleWalletInitialization() {
    let {
      hasWalletDataToCompare
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (hasWalletDataToCompare) {
      dispatch(paymentsDuck.creators.updateMyWallet({
        displayModal: true,
        selectedPanelName: 'compareWalletData'
      }));
    } else if (typeof window !== 'undefined' && window.location.hash === '#showWallet') {
      dispatch(paymentsDuck.creators.updateMyWallet({
        displayModal: true
      }));
    }
  }
  function handleCompareLoggedInWalletData() {
    eventBus.emit(WALLET_UPDATE_DATA_AFTER_LOGIN_REQUEST);
  }
  useEffect(() => {
    eventBus.on(WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, handleWalletInitialization);
    dispatch(paymentsDuck.creators.ensurePaymentsInfo());
    return () => {
      eventBus.off(WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, handleWalletInitialization);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    eventBus.on(AUTH_SIGNIN_COMPLETE, handleCompareLoggedInWalletData);
    return () => {
      eventBus.off(AUTH_SIGNIN_COMPLETE, handleCompareLoggedInWalletData);
    };
  }, []);
  return null;
}
export { useWalletInitialization as default };
